import axios from 'axios';
import {
  MAIL_SENDER_API_DOMAIN, MAIL_SENDER_API_KEY,
} from './constants';


// Запрос к API рассылки
let axiosMailSenderAPI = axios.create({
  baseURL: MAIL_SENDER_API_DOMAIN,
  withCredentials: false,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data',
  },
})
// Интерцептор: прикрепляет заголовок авторизации с токеном
axiosMailSenderAPI.interceptors.request.use(
  (config) => {
    config.headers['Api-key'] = MAIL_SENDER_API_KEY;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
)

export { axiosMailSenderAPI }
